// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"56f8b22b","843":"1a92928a","941":"96c6dd10"}[chunkId] + ".chunk.css";
};